
import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import {
  HisInformationItemDefaultSelectBehavior,
  HisInformationItemDefaultSelectKinds
} from "../../../../../../documaker/domain/format/objects";
import {
  instanceOfIHisInformationKeyPropertyEditable,
  instanceOfIHisInformationItemDefaultSelectBehaviorPropertyEditable
} from "../../../../../domain/editableFormat/properties";
import { HisInformationSetting } from "../../../../../../base/domain/his";
import { IFormatObjectEditable } from "../../../../../domain/editableFormat";
import { CommonComponentsContainer } from "../../contents";

@Component
export default class HisInformationKeyPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IFormatObjectEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IFormatObjectEditable) => T, defaultValue: T) => T;
  editingSource: IFormatObjectEditable;
  // CommonComponentsAccessibleMixinと同時に使う事.CommonComponentsAccessibleMixin利用APIの宣言.
  getCommonComponents: () => CommonComponentsContainer;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isHisInformationKeyEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIHisInformationKeyPropertyEditable(s) && s.hisInformationKey().isEditable(), false);
  }

  get isHisInformationKeySelectable(): boolean {
    return this.isHisInformationKeyEditable
        && (1 < this.hisInformationItems.length);
  }

  get hisInformationKey(): string {
    return this.readPropertyOrDefault(s => s.hisInformationKey().getValue(), "");
  }

  get hisInformationName(): string {
    return this.readPropertyOrDefault(s => s.getHisInformationName(), "");
  }

  set hisInformationName(value: string) {
    this.writePropertyWhenValid(s => {
      this.updateHisInformationItemDefaultSelect(s, value, this.hisInformationKey);
      s.hisInformationKey().setValue(value);
    });
  }

  private updateHisInformationItemDefaultSelect(source: IFormatObjectEditable, newKey: string, oldKey: string) {
    if (newKey !== oldKey &&
      instanceOfIHisInformationItemDefaultSelectBehaviorPropertyEditable(source) &&
      source.hisInformationItemDefaultSelectBehavior().isEditable()) {
      // 作成日以外から作成日に変更した場合、初期選択を作成日に変更する
      if (newKey === "CREATE_DATE" &&
        Enumerable.from(source.getSelectableHisInformationItemDefaultSelectKinds()).any(s => s === HisInformationItemDefaultSelectKinds.CreatedDate)) {
        source.hisInformationItemDefaultSelectBehavior().setValue(new HisInformationItemDefaultSelectBehavior(true, HisInformationItemDefaultSelectKinds.CreatedDate));
        return;
      }
      // 作成日から作成日以外に変更した場合、初期選択を先頭に変更し無効とする
      if (oldKey === "CREATE_DATE" &&
        Enumerable.from(source.getSelectableHisInformationItemDefaultSelectKinds()).any(s => s === HisInformationItemDefaultSelectKinds.Top)) {
        source.hisInformationItemDefaultSelectBehavior().setValue(new HisInformationItemDefaultSelectBehavior(false, HisInformationItemDefaultSelectKinds.Top));
        return;
      }
    }
  }

  get hisInformationItems(): HisInformationSetting[] {
    const typeName = this.readPropertyOrDefault(s => s.objectTypeName().getValue(), "");
    const selectableHisInformations = this.readPropertyOrDefault(s => s.getSelectableHisInformations(), []);
    const selectableHisInformationKeys = Enumerable.from(selectableHisInformations).select(i => i.key).toArray();
    return selectableHisInformations
      .concat(this.isHisInformationMixable
        ? Enumerable.from(this.getCommonComponents().allPagesFormatObjects)
          .where(o => o.objectTypeName().getValue() === typeName)
          .select(o => o.hisInformationKey().getValue())
          .distinct()
          .where(n => n && (selectableHisInformationKeys.indexOf(n) < 0))
          .select(n => new HisInformationSetting(
            "",
            n,
            "ALL",
            typeName.toUpperCase(),
            false,
            true,
            true,
            "STR",
            false,
            "NONE",
            false,
            "NONE",
            "NONE",
            "",
            false,
          ))
          .toArray()
        : []);
  }

  getHisInformationItem(key: string): HisInformationSetting {
    return Enumerable.from(this.hisInformationItems).firstOrDefault(s => s.key === key);
  }

  get isHisInformationMixable(): boolean {
    return this.readPropertyOrDefault(s => s.isHisInformationMixable(), false);
  }

  get selectedHisItemType(): string {
    const selectedItem = this.getHisInformationItem(this.hisInformationKey);
    return selectedItem ? selectedItem.itemType : "";
  }
  
  async showHisNameSelectDialog() {
    const dialog = this.isHisInformationMixable
      ? this.getCommonComponents().getDialogs().getHisInformationItemSelectDialog()
      : this.getCommonComponents().getDialogs().gethisInformationTypeItemSelectDialog();
    const selectedItem = await dialog.show(this.hisInformationItems, this.getHisInformationItem(this.hisInformationKey));
    if (!selectedItem) { return; }
    // キーがない場合は手入力されたitemなのでnameを設定
    this.hisInformationName = !selectedItem.key ? selectedItem.name : selectedItem.key;
  }
}
